var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoadMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "load_more_svg__Ebene_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 74 74",
  style: {
    enableBackground: "new 0 0 74 74"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".load_more_svg__st1{fill:url(#load_more_svg__SVGID_00000142886140754622713030000013805106275210140805_)}")), /*#__PURE__*/React.createElement("linearGradient", {
  id: "load_more_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: -17.618,
  y1: -8.799,
  x2: 82.382,
  y2: 75.201
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#0841db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.517,
  style: {
    stopColor: "#ff0b98"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#c6243b"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#load_more_svg__SVGID_1_)"
  },
  d: "M38.5 22h-2v14.5H22v2h14.5V53h2V38.5H53v-2H38.5z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "load_more_svg__SVGID_00000109715701173528643590000015329431550116510886_",
  gradientUnits: "userSpaceOnUse",
  x1: -17.579,
  y1: -8.846,
  x2: 82.421,
  y2: 75.154
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#0841db"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.517,
  style: {
    stopColor: "#ff0b98"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#c6243b"
  }
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "url(#load_more_svg__SVGID_00000109715701173528643590000015329431550116510886_)"
  },
  d: "M37 0C16.6 0 0 16.6 0 37s16.6 37 37 37 37-16.6 37-37S57.4 0 37 0zm13.6 69.2C46.3 71.1 41.7 72 37 72 17.7 72 2 56.3 2 37S17.7 2 37 2s35 15.7 35 35c0 14.1-8.4 26.8-21.4 32.2z"
}));
export default SvgLoadMore;